import React, { useEffect } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Box, Link, LinkButton, Typography } from "@bca/ui-library";

import ExclamationCircleSVG from "./Icons/ExclamationCircleSVG";
import generalErrorDataPush from "./AdobeDataPushes/errors/generalErrorDataPush";

const Container = styled(Box)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  ${css({
    maxWidth: ["100%", "100%", "100%", 1440],
    px: [5, 5, 60, 60],
  })}
`;

const GeneralErrorPage = () => {
  useEffect(() => {
    generalErrorDataPush();
  }, []);

  return (
    <Container
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100vh - 710px)"
      paddingY={60}
    >
      <ExclamationCircleSVG width="fit-content" fill="primary-red" />
      <Typography variant="h4" htmlTag="h2" my={6} textAlign="center">
        We’ve encountered an unexpected technical issue
      </Typography>
      <Typography
        variant="body-lg"
        m={0}
        mb={40}
        color="grey-blue"
        textAlign="center"
        css={`
          max-width: 715px;
        `}
      >
        Unfortunately, we’re unable to proceed with your request, please try
        again or check back later. If this error persists please{" "}
        <Link
          href={`${process.env.VIRTUAL_DOMAIN}contact/`}
          color="primary-light-blue"
          data-en="click"
          data-ec="button"
          data-el="contact-support"
          data-ea="navigate"
        >
          contact support
        </Link>
        .
      </Typography>
      <LinkButton
        link=""
        shouldOpenInNewWindow={false}
        variant="secondary"
        width="100%"
        maxWidth={200}
        height={60}
        data-en="click"
        data-ec="button"
        data-el="retry"
        data-ea="navigate"
      >
        Retry
      </LinkButton>
    </Container>
  );
};

export default GeneralErrorPage;
